import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/AGB";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/agb")({
  head: () => pageHead("/agb"),
  component: Page,
});
